import joinUsBannerXs from './join-us-banner-xs.jpg';
import joinUsBannerSm from './join-us-banner-sm.jpg';
import joinUsBannerMd from './join-us-banner-md.jpg';
import joinUsBannerLg from './join-us-banner-lg.jpg';
import joinUsBannerXl from './join-us-banner-xl.jpg';

export default {joinUsBannerXs, joinUsBannerSm, joinUsBannerMd, joinUsBannerLg, joinUsBannerXl}
